import { COLORS, FlexView } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const InfoItem = styled(FlexView)`
  width: 50%;
`;
const InfoWrapper = styled(FlexView)`
  flex-wrap: wrap;
`;
const ButtonWrapper = styled(FlexView)`
  margin-left: -5px;
`;
const LabelWrapper = styled(Text)`
  white-space: pre-line;
`;
const TagWrapper = styled(FlexView)`
  background-color: ${COLORS.AQUAMARINE};
  border-radius: 4px;
  margin-left: 8px;
`;

const TeacherDetails = ({
  id,
  name,
  timeInCuemath,
  studentsTaught,
  studentsInSelectedCountry,
  studentsInSelectedGradeCohort,
  isDAenabledTeacher,
}) => {
  const infoItem = (label, value, shouldRenderMargin = true) => (
    <InfoItem>
      <Text variant="h6">{value}</Text>
      <LabelWrapper variant="body3" color={COLORS.COLA_LIGHTER}>
        {label}
      </LabelWrapper>
      {shouldRenderMargin && <Separator height={16} />}
    </InfoItem>
  );

  const renderDATag = (
    <TagWrapper gap={1} gutter={8}>
      <Text variant="eyebrow2">DA</Text>
    </TagWrapper>
  );

  const onViewTeacherDetails = () => window.open(`/users/teachers/${id}`, '_blank');

  return (
    <>
      <ButtonWrapper flexDirection="row" alignItems="center" justifyContent="flex-start">
        <Button
          variant="tertiaryWithUnderline"
          size="medium"
          onClick={onViewTeacherDetails}
          label={name}
        />
        {isDAenabledTeacher && renderDATag}
      </ButtonWrapper>
      <Separator height={16} />
      <InfoWrapper flexDirection="row">
        {infoItem('Time in\nCuemath', timeInCuemath)}
        {infoItem('Students\ntaught', studentsTaught)}
        {infoItem('Same grade\ncohort', studentsInSelectedGradeCohort, false)}
        {infoItem('Students from\nsame country', studentsInSelectedCountry, false)}
      </InfoWrapper>
    </>
  );
};

TeacherDetails.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  timeInCuemath: PropTypes.string,
  studentsTaught: PropTypes.string,
  studentsInSelectedCountry: PropTypes.string,
  studentsInSelectedGradeCohort: PropTypes.string,
  isDAenabledTeacher: PropTypes.bool,
};

export default TeacherDetails;
